import { UserFacingError } from './errors'

export class ProRequiredError extends UserFacingError {
  constructor() {
    super('BlindBook Pro is required to create a crew.')
    this.name = 'ProRequiredError'
  }
}
